module.exports = __webpack_public_path__ + "static/media/Zone2RightHipOverlay.c4feb442.png";